export function twitchMarketGames(games, period, sortBy) {
  return games.map(game => {
    const primary = game.displayMinutes ?? (period === "now" ? game.currentViewers : game.viewMinutes);
    const secondary = game.displayPeak ?? (period === "now" ? game.activeStreamers : game.peak);
    const value = sortBy === "peak" ? Number(secondary) : Number(primary) / (period === "now" ? 1 : 60);
    return { ...game, id: String(game.id), mindshare: value };
  }).filter(game => Number.isFinite(game.mindshare) && game.mindshare > 0)
    .sort((a, b) => b.mindshare - a.mindshare);
}

export const twitchMarketMetricLabel = (period, sortBy) => sortBy === "peak"
  ? (period === "now" ? "Streamers" : "Peak Viewers")
  : (period === "now" ? "Viewers" : "Hours Watched");
